import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { AbStatsReportGetInput } from '@libs/types/src/inbox/input-type/ab-stats-report.get-input';
import { AbStatsReportObject } from '@libs/types/src/inbox/object-type/ab-stats-report.object';
import { AbStatsReportUpsertInput } from '@libs/types/src/inbox/input-type/ab-stats-report.upsert-input';
import { AbStatsReportDeleteInput } from '@libs/types/src/inbox/input-type/ab-stats-report.delete-input';

@Injectable({ providedIn: 'root' })
export class AbStatsReportGqlService extends GqlServiceV2 {

    public async getAbStatsReports(input: AbStatsReportGetInput, fragment: string) {
        return this.query<AbStatsReportObject[]>(
            `
                query($input: AbStatsReportGetInput!) {
                    abStatsReport {
                        get(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async upsertAbStatsReport(input: AbStatsReportUpsertInput, fragment: string) {
        return this.mutate<AbStatsReportObject>(
            `
                mutation($input: AbStatsReportUpsertInput!) {
                    abStatsReport {
                        upsert(input: $input) {
                            ${fragment}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public async deleteAbStatsReport(input: AbStatsReportDeleteInput) {
        return this.mutate(
            `
                mutation($input: AbStatsReportDeleteInput!) {
                    abStatsReport {
                        delete(input: $input) {
                            ok
                        }
                    }
                }
            `,
            { input },
        );
    }
}
